@if (isEditMode) {
  <form class="section no-padding" [formGroup]="form" [ngClass]="{ loading: isReaderCardFormLoading }">
    <div class="heading-wrapper readers-card open">
      <div class="header-wrapper">
        <h4>
          {{ 'pages.client.readersCard.title' | translate }}
        </h4>
        <app-tooltip text="readersCardHeaderInfoBo" [marginBottom]="false"></app-tooltip>
      </div>
      @if (isDesktopMdPlus && !client.isDeleted) {
        <div class="actions">
          <button class="primary" (click)="submit()">
            {{ 'pages.client.saveChanges' | translate }}
          </button>
          <button class="secondary cancel" (click)="setIsEditMode(false, !hasFormChanged)">
            {{ 'pages.client.cancel' | translate }}
          </button>
        </div>
      }
    </div>
    <div class="lna-row">
      <div>
        <div class="label-wrapper">
          <label class="form-label lna" for="education">
            {{ 'pages.client.readersCard.education' | translate }}
            <span class="required-field">*</span>
          </label>
          <app-tooltip text="educationBackoffice" />
        </div>

        <select formControlName="education">
          <option [value]="null" [selected]="education?.value === null" disabled>
            {{ 'pages.client.readersCard.educationDefaultOption' | translate }}
          </option>
          @for (educationLevel of educationLevels; track educationLevel.id) {
            <option value="{{ educationLevel.id }}">
              {{ educationLevel.name }}
            </option>
          }
        </select>
        <div class="error-wrapper">
          @if (this.shouldRenderError('education') && education?.errors) {
            @if (education?.errors?.['required']) {
              <small class="error-message">
                {{ 'components.form.errorRequired' | translate }}
              </small>
            } @else if (education?.errors?.['minlength']) {
              <small class="error-message">
                {{
                  'components.form.minLength'
                    | translate
                      : {
                          name: education?.errors?.['minlength']['requiredLength']
                        }
                }}
              </small>
            } @else if (education?.errors?.['maxlength']) {
              <small class="error-message">
                {{
                  'components.form.maxLength'
                    | translate
                      : {
                          maxLength: education?.errors?.['maxlength']['requiredLength']
                        }
                }}
              </small>
            }
          }
        </div>
      </div>
      @if (isHigherEducation) {
        <div>
          <div class="label-wrapper">
            <label class="form-label lna" for="degree">
              {{ 'pages.client.readersCard.degree' | translate }}
            </label>
          </div>
          <select formControlName="degree">
            <option [value]="null" [selected]="degree?.value === null" disabled>
              {{ 'pages.client.readersCard.degreeDefaultOption' | translate }}
            </option>
            @for (scientificDegree of scientificDegrees; track scientificDegree.id) {
              <option [value]="scientificDegree.id">
                {{ scientificDegree.name }}
              </option>
            }
          </select>
        </div>
      }
    </div>
    <div class="lna-row last full-width">
      <div>
        <div class="label-wrapper">
          <p class="form-label lna">
            {{ 'pages.client.readersCard.fileUploadTitle' | translate }}
          </p>
          <app-tooltip text="readersCardFileUploadBackoffice" />
        </div>
        <app-file-upload
          [isEditMode]="true"
          [existingFiles]="readersCard?.doctoralCertificateFiles || []"
          [type]="doctoralFileType"
          [associatedEntityId]="readersCard?.id!"
          [isSubmitting]="isSubmittingFiles"
          (uploading)="handleFileRequests($event)" />
      </div>
      @if (!isDesktopMdPlus) {
        <div class="bottom-actions">
          <button class="primary" (click)="submit()">
            {{ 'pages.client.saveChanges' | translate }}
          </button>
          <button class="secondary cancel" (click)="setIsEditMode(false, !hasFormChanged)">
            {{ 'pages.client.cancel' | translate }}
          </button>
        </div>
      }
      @if (isDoctoralDegreeSelected()) {
        <div class="info-row danger">
          <img [attr.alt]="'imgAlt.infoIcon.svg' | translate" src="assets/images/danger-exclamation-mark.svg" />
          <p>{{ 'pages.service.visitRoom.summary.mustShowDoctoralCertificate' | translate }}</p>
        </div>
      }
    </div>
  </form>
  @if (isReaderCardFormLoading) {
    <div class="section">
      <app-spinner [isLoading]="true" />
    </div>
  }
} @else {
  @if (client.hasReaderCard) {
    <div class="section no-padding">
      <div class="heading-wrapper readers-card open">
        <div class="header-wrapper">
          <h4>{{ 'pages.client.readersCard.title' | translate }}</h4>
          <app-tooltip text="readersCardHeaderInfoBo" [marginBottom]="false"></app-tooltip>
        </div>
        @if (!client.isDeleted) {
          <div class="actions">
            <button class="secondary edit-btn" (click)="setIsEditMode(true, true)">
              <img src="/assets/images/edit-icon.svg" alt="edit icon" />
              {{ 'pages.client.editClient' | translate }}
            </button>
          </div>
        }
      </div>
      <div class="lna-row">
        <div class="value-wrapper">
          <div class="label-wrapper">
            <p class="form-label">
              {{ 'pages.client.readersCard.education' | translate }}
            </p>
            <app-tooltip text="educationBackoffice" />
          </div>
          <p class="form-value">{{ readersCard?.educationLevelName || '-' }}</p>
        </div>
        @if (isHigherEducation) {
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.readersCard.degree' | translate }}
            </p>
            <p class="form-value">
              {{ readersCard?.scientificDegreeName || '-' }}
            </p>
          </div>
        }
      </div>
      <div class="lna-row last full-width">
        <div class="value-wrapper file-list m-0">
          <div class="label-wrapper">
            <p class="form-label">
              {{ 'pages.client.readersCard.educationDocuments' | translate }}
            </p>
            <app-tooltip text="readersCardFileUploadBackoffice" />
          </div>
          <app-file-upload
            [isEditMode]="false"
            [existingFiles]="readersCard?.doctoralCertificateFiles || []"
            [type]="doctoralFileType"
            [associatedEntityId]="readersCard?.id!"
            [isSubmitting]="isSubmittingFiles"
            (uploading)="handleFileRequests($event)" />
        </div>
        @if (readersCard?.doctoralCertificateFiles?.length === 0 && readersCard?.scientificDegreeName === 'Doktors') {
          <div class="info-row danger">
            <img [attr.alt]="'imgAlt.infoIcon.svg' | translate" src="assets/images/danger-exclamation-mark.svg" />
            <p>{{ 'pages.service.visitRoom.summary.mustShowDoctoralCertificate' | translate }}</p>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="section">
      <div class="heading-wrapper">
              <div class="header-wrapper">
                <h4>
                  {{ 'pages.client.readersCard.title' | translate }}
                </h4>
                <app-tooltip text="readersCardHeaderInfoBo" [marginBottom]="false"></app-tooltip>
              </div>
      </div>
      <p class="no-card">{{ 'pages.client.readersCard.noCard' | translate }}</p>
      @if (!client.isDeleted) {
        <button class="primary" (click)="setIsEditMode(true, true)">
          {{ 'pages.client.readersCard.addCard' | translate }}
        </button>
      }
    </div>
  }
  @if (client.hasReaderCard) {
    <div class="section no-padding" [ngClass]="{ open: !isResearchTopicsCollapsed }">
      <div class="heading-wrapper topics" [ngClass]="{ open: !isResearchTopicsCollapsed }">
        <div
          class="inline"
          (keydown.enter)="isResearchTopicsCollapsed = !isResearchTopicsCollapsed"
          (click)="isResearchTopicsCollapsed = !isResearchTopicsCollapsed"
          tabindex="0">
          <h4 class="p-0">{{ 'pages.client.readersCard.researchTopics' | translate }}</h4>
          @if (researchTopics.length === 0) {<app-tooltip [marginBottom]="false" text="chooseTopicsTooltipBackoffice" />}
        </div>
        <div class="actions">
          @if (!client.isDeleted) {
            <button class="secondary add-topic-btn" (click)="navigateTo('petijuma-tema/pievienot/' + client.id)">
              <img [attr.alt]="'imgAlt.addTopic' | translate" src="assets/images/add-icon-black.svg" />
              @if (isDesktopSm) {
              } @else if (isMobile) {
                {{ 'pages.client.addTopicMobile' | translate }}
              } @else {
                {{ 'pages.client.addTopic' | translate }}
              }
            </button>
          }
        </div>
      </div>
      <div class="topics">
        @if (researchTopics.length === 0) {
          <p class="no-topics">{{ 'pages.client.noTopics' | translate }}</p>
        }
        @for (researchTopic of researchTopics; track researchTopic.id) {
          @if ($index >= (page - 1) * pageSize && $index < page * pageSize) {
            <div class="topic-wrapper" [ngClass]="{ open: !researchTopicsCollapsed[$index] }">
              <div class="topic">
                <div
                  class="name-wrapper"
                  (click)="researchTopicsCollapsed[$index] = !researchTopicsCollapsed[$index]"
                  (keydown.enter)="researchTopicsCollapsed[$index] = !researchTopicsCollapsed[$index]"
                  tabindex="0">
                  <div class="topic-name">
                    <img
                      [ngClass]="{
                        chevron: true,
                        open: !researchTopicsCollapsed[$index]
                      }"
                      src="assets/images/chevron-icon.svg"
                      alt="arrow" />
                    <div class="topic-name_wrapper">
                      <p>{{ researchTopic.name }}</p>
                      @if (hasExpiredFiles(researchTopic)) {
                        <div class="message_wrapper">
                          <img src="/assets/images/danger-exclamation-mark.svg" alt="edit icon" />
                          <small class="error-message">
                            {{ 'pages.client.readersCard.expiredResearchTopicFilesError' | translate }}
                          </small>
                        </div>
                      }
                    </div>
                  </div>
                  @if (!isDesktopLgPlus) {
                    <p class="topic-status" [ngClass]="[researchTopic.isActive ? 'status-active' : 'status-inactive']">
                      {{ 'pages.client.readersCard.' + (researchTopic.isActive ? 'active' : 'inactive') | translate }}
                    </p>
                  }
                </div>
                <div class="actions-row">
                    <div class="actions topic-actions">
                      @if (researchTopic.createdByType === 'User') {
                        @if (researchTopic.isEditable) {
                          <button class="link-btn" (click)="navigateTo('petijuma-tema/rediget/' + researchTopic.id + '/' + client.id)">
                            <img src="/assets/images/edit-icon.svg" alt="edit icon" />
                            {{ 'pages.client.editTopic' | translate }}
                            <app-tooltip [withMargin]="true" [marginBottom]="false" text="editTopicBackoffice" />
                          </button>
                          <button class="link-btn" (click)="deleteTopic(researchTopic.id)">
                            <img src="/assets/images/delete-icon.svg" alt="edit icon" />
                            {{ 'pages.client.deleteTopic' | translate }}
                            <app-tooltip [withMargin]="true" [marginBottom]="false" text="deleteTopicBackoffice" />
                          </button>
                        }
                        @if (researchTopic.isActive) {
                          <button class="link-btn" (click)="updateTopicStatus(researchTopic.id)">
                            <img class="eye-icon" src="/assets/images/deactivate-icon.svg" alt="edit icon" />
                            {{ 'pages.client.deactivateTopic' | translate }}
                            <app-tooltip [withMargin]="true" [marginBottom]="false" text="changeTopicStatusBackoffice" />
                          </button>
                        } @else {
                          <button class="link-btn" (click)="updateTopicStatus(researchTopic.id)">
                            <img class="eye-icon" src="/assets/images/activate-icon.svg" alt="activate icon" />
                            {{ 'pages.client.activateTopic' | translate }}
                            <app-tooltip [withMargin]="true" [marginBottom]="false" text="changeTopicStatusBackoffice" />
                          </button>
                        }
                      }
                    </div>
                  @if (isDesktopLgPlus) {
                    <p class="topic-status" [ngClass]="[researchTopic.isActive ? 'status-active' : 'status-inactive']">
                      {{ 'pages.client.readersCard.' + (researchTopic.isActive ? 'active' : 'inactive') | translate }}
                    </p>
                  }
                </div>
              </div>
              <div class="topic-collapsible" [ngbCollapse]="researchTopicsCollapsed[$index]">
                <app-topic-info [topic]="researchTopic" />
              </div>
            </div>
          }
        }
      </div>
    </div>
  }
  @if (researchTopics.length > 10) {
    <div class="pagination-wrapper">
      <p class="total">{{ 'components.table.total' | translate }} {{ researchTopics.length }}</p>
      <ngb-pagination
        [(page)]="page"
        [pageSize]="pageSize"
        [collectionSize]="researchTopics.length"
        [maxSize]="5"
        [ellipses]="true"
        (pageChange)="page = $event" />
      <select class="page-size" (change)="onPageSizeChange($event)">
        <option [selected]="pageSize === 10" [value]="10">10 / {{ 'components.table.pageSize' | translate }}</option>
        <option [selected]="pageSize === 20" [value]="20">20 / {{ 'components.table.pageSize' | translate }}</option>
        <option [selected]="pageSize === 50" [value]="50">50 / {{ 'components.table.pageSize' | translate }}</option>
        <option [selected]="pageSize === 100" [value]="100">100 / {{ 'components.table.pageSize' | translate }}</option>
      </select>
    </div>
  }
  <app-confirm-modal
    [isOpen]="isOpenConfirmDelete"
    (confirm)="deleteTopic(topicToDelete)"
    (cancel)="onModalClose()"
    title="deleteResearchTopic" />
  <app-confirm-modal
    [title]="getTopicToChangeStatusIsActive() ? 'deactivateTopic' : 'activateTopic'"
    [bodyText]="getTopicToChangeStatusIsActive() ? 'deactivateTopicBody' : 'activateTopicBody'"
    [confirmText]="getTopicToChangeStatusIsActive() ? 'deactivate' : 'activate'"
    [isOpen]="isOpenConfirmChangeStatus"
    (confirm)="updateTopicStatus(topicToChangeStatus)"
    (cancel)="onModalClose()" />
}

<app-confirm-modal
  title="unsavedChanges"
  bodyText="unsavedChangesBody"
  confirmText="confirm"
  denyText="cancelBack"
  [isOpen]="isOpenConfirmLeave"
  (cancel)="onModalClose()"
  (confirm)="setIsEditMode(false, true)" />
